(function() {
  'use strict';

  // Google Maps initialization
  function initGoogleMap(container) {
    const apiKey = container.getAttribute('data-api-key');
    const mapAddress = container.getAttribute('data-map-address');
    const mapId = container.getAttribute('data-map-id') || 'DEMO_MAP_ID';
    const mapElement = container.querySelector('.google-map');

    if (!apiKey || !mapAddress || !mapElement) {
      return;
    }

    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      initializeMap();
    } else {
      // Load Google Maps API
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker&callback=initGoogleMapCallback`;
      script.async = true;
      script.defer = true;
      
      // Create a unique callback function name
      const callbackName = 'initGoogleMapCallback_' + Date.now();
      window[callbackName] = function() {
        initializeMap();
        delete window[callbackName];
      };
      
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker&callback=${callbackName}`;
      document.head.appendChild(script);
    }

    function initializeMap() {
      if (!window.google || !window.google.maps) {
        console.error('Google Maps API not loaded');
        return;
      }

      // Map options
      const mapOptions = {
        mapId: mapId,
        zoom: 15,
        center: { lat: 0, lng: 0 }, // Will be updated after geocoding
        disableDefaultUI: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true
      };

      // Initialize map
      const map = new google.maps.Map(mapElement, mapOptions);
      container._map = map;

      // Geocode the address
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: mapAddress }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const location = results[0].geometry.location;
          
          // Set map center
          map.setCenter(location);
          
          // Create marker using AdvancedMarkerElement
          const pinElement = new google.maps.marker.PinElement({
            background: '#000000',
            borderColor: '#000000',
            glyphColor: '#FFFFFF',
            scale: 1.2
          });

          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: location,
            content: pinElement.element,
            title: mapAddress
          });

          // Store marker reference
          container._marker = marker;
          container._pinElement = pinElement;

          // Add click listener to open Google Maps
          marker.addEventListener('click', function() {
            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapAddress)}`, '_blank');
          });
        } else {
          console.error('Geocoding failed:', status);
        }
      });

      // Handle window resize
      google.maps.event.addDomListener(window, 'resize', function() {
        const center = map.getCenter();
        if (center) {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        }
      });
    }
  }

  // Initialize all maps on page load
  function initAllMaps() {
    const mapContainers = document.querySelectorAll('[data-google-map]');
    mapContainers.forEach(function(container) {
      if (!container._initialized) {
        container._initialized = true;
        initGoogleMap(container);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMaps);
  } else {
    initAllMaps();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const mapContainers = event.target.querySelectorAll('[data-google-map]');
    mapContainers.forEach(function(container) {
      if (!container._initialized) {
        container._initialized = true;
        initGoogleMap(container);
      }
    });
  });

  // Function to update map location (for location input)
  window.updateMapLocation = function(container, newAddress) {
    if (!container || !container._map) {
      return;
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: newAddress }, function(results, status) {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const location = results[0].geometry.location;
        
        // Update map center
        container._map.setCenter(location);
        
        // Update marker position if it exists
        if (container._marker) {
          container._marker.position = location;
        } else {
          // Create new marker if it doesn't exist
          const pinElement = new google.maps.marker.PinElement({
            background: '#000000',
            borderColor: '#000000',
            glyphColor: '#FFFFFF',
            scale: 1.2
          });

          container._marker = new google.maps.marker.AdvancedMarkerElement({
            map: container._map,
            position: location,
            content: pinElement.element,
            title: newAddress
          });

          container._pinElement = pinElement;
        }

        // Update data attribute
        container.setAttribute('data-map-address', newAddress);
      } else {
        console.error('Geocoding failed:', status);
      }
    });
  };

})();
